//see https://stackoverflow.com/questions/45019317/matdatepicker-start-week-on-monday
//enures that the week begins on a monday

import { Injectable } from "@angular/core";
import { NativeDateAdapter } from "@angular/material/core";


@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  getFirstDayOfWeek(): number {
     return 1;
   }
}
